import { render } from "./AccountInqueryChat.vue?vue&type=template&id=33187dc7"
import script from "./AccountInqueryChat.vue?vue&type=script&lang=js"
export * from "./AccountInqueryChat.vue?vue&type=script&lang=js"

import "./AccountInqueryChat.vue?vue&type=style&index=0&id=33187dc7&lang=css"

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__